module.exports = __webpack_public_path__ + "images/apps/lark-8041ae66a9c10c7a989a57346c97d686.png";